import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { Button, Col, Modal, ModalHeader, ModalBody, Row } from "reactstrap";
import { CreateNewOrgSPOC } from "services/OrganizationSPOCServices";
import cross from "../../../assets/images/icon/cross.svg";
const CreateSPOCModal = ({
  t,
  addModal,
  setAddModal,
  orgDetails,
  fetchData,
  ...props
}) => {
  const [spocDetails, setSPOCDetails] = useState({});
  const [errors, setErrors] = useState({});

  const toggleAddModal = () => {
    setAddModal(!addModal);
    setSPOCDetails({});
    setErrors({});
  };

  const validateForm = () => {
    let newErrors = {};
    const nameRegex = /^[A-Za-z\s.]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^\d{10,10}$/;
    
    if (!spocDetails?.name?.trim()) {
      newErrors.name = t("Organization.SPOC.Name is required");
    } else if (!nameRegex.test(spocDetails.name.trim())) {
      newErrors.name = t("Organization.SPOC.Name should contain only alphabets");
    }

    if (!spocDetails?.email_id?.trim()) {
      newErrors.email_id = t("Organization.SPOC.Email is required");
    } else if (!emailRegex.test(spocDetails.email_id.trim())) {
      newErrors.email_id = t("Organization.SPOC.Enter a valid email");
    }
    if (!spocDetails?.mobile_no?.trim()) {
      newErrors.mobile_no = t("Organization.SPOC.Mobile number is required");
    } else if (!mobileRegex.test(spocDetails.mobile_no.trim())) {
      newErrors.mobile_no = t("Organization.SPOC.Enter a valid mobile number (10 digits)");
    } else if (/^0{10}$/.test(spocDetails.mobile_no.trim())) {
      newErrors.mobile_no = t("Organization.SPOC.Enter a valid mobile number (10 digits)");
    }
    if (!spocDetails?.role?.trim()) {
      newErrors.role = t("Organization.SPOC.Role is required");
    } else if (!nameRegex.test(spocDetails.role.trim())) {
      newErrors.role = t("Organization.SPOC.Role should contain only alphabets and spaces");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveClick = async () => {
    if (!validateForm()) return;

    try {
      let reqBody = {
        organization_id: orgDetails?.id,
        name: spocDetails?.name?.trim(),
        email_id: spocDetails?.email_id?.trim(),
        mobile_no: spocDetails?.mobile_no?.trim(),
        role: spocDetails?.role?.trim(),
      };

      let response = await CreateNewOrgSPOC(reqBody);
      let responseMsg = response?.data?.message || "SPOC Created Successfully";

      toast.success(responseMsg);
      setTimeout(() => {
        toggleAddModal();
        fetchData({});
      }, 1000);
    } catch (error) {
      let errMsg =
        error?.response?.data?.message ||
        error?.response?.message ||
        error?.message ||
        "Error while creating SPOC";

      let errorData = error?.response?.data?.errors || {};
      setErrors(errorData);

      toast.error(errMsg);
    }
  };

  return (
    <>
      <Modal
        size="lg"
        isOpen={addModal}
        centered
        backdrop="static"
        toggle={toggleAddModal}
        className="edit-modal-card ediOrganizations"
      >
        {/* <ModalHeader tag="h4" toggle={toggleAddModal}></ModalHeader> */}

        <ModalBody>
          <div className="">
            <div className="filters-cards-cross">
              <div className="filter-content">
                <h4> {t(`Organization.SPOC.Add SPOC Details`)} </h4>
              </div>
              <div className="filter-content cross">
                <img
                  src={cross}
                  alt=""
                  onClick={() => {
                    toggleAddModal();
                  }}
                />
              </div>
            </div>
            <Row className="">
              <Col md={12} className="">
                <Form.Group className="mb-2 floating-label">
                  <Form.Label className="float-label">
                    {t(`Organization.SPOC.Name`)}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    placeholder={t(`Organization.SPOC.Enter Name`)}
                    type="text"
                    name="name"
                    value={spocDetails?.name}
                    onChange={e => {
                      setSPOCDetails({
                        ...spocDetails,
                        name: e.target.value,
                      });
                      setErrors({
                        ...errors,
                        name: !!e?.target?.value?.trim()
                          ? null
                          : t("Organization.SPOC.Name is required"),
                      });

                      setTimeout(() => {
                        setErrors({
                          ...errors,
                          name: null,
                        });
                      }, 2500);
                    }}
                    title={t(`Organization.SPOC.Name`)}
                  />
                  {errors?.name && (
                    <p className="text-danger">{errors?.name}</p>
                  )}
                </Form.Group>
              </Col>

              <Col md={12} className="">
                <Form.Group className="mb-2 floating-label">
                  <Form.Label className="float-label">
                    {t(`Organization.SPOC.Email`)}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    placeholder={t(`Organization.SPOC.Enter Email`)}
                    type="email"
                    name="email_id"
                    value={spocDetails?.email_id}
                    onChange={e => {
                      setSPOCDetails({
                        ...spocDetails,
                        email_id: e.target.value,
                      });
                      setErrors({
                        ...errors,
                        email_id: !!e?.target?.value?.trim()
                          ? null
                          : t("Organization.SPOC.Email is required"),
                      });

                      setTimeout(() => {
                        setErrors({
                          ...errors,
                          email_id: null,
                        });
                      }, 2500);
                    }}
                    title={t(`Organization.SPOC.Email`)}
                  />
                  {errors?.email_id && (
                    <p className="text-danger">{errors?.email_id}</p>
                  )}
                </Form.Group>
              </Col>

              <Col md={12} className="">
                <Form.Group className="mb-2 floating-label">
                  <Form.Label className="float-label">
                    {t(`Organization.SPOC.Mobile`)}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    placeholder={t(`Organization.SPOC.Enter Mobile No`)}
                    type="tel"
                    name="mobile_no"
                    value={spocDetails?.mobile_no}
                    onChange={e => {
                      setSPOCDetails({
                        ...spocDetails,
                        mobile_no: e.target.value,
                      });
                      setErrors({
                        ...errors,
                        mobile_no: !!e?.target?.value?.trim()
                          ? null
                          : t("Organization.SPOC.Mobile number is required"),
                      });

                      setTimeout(() => {
                        setErrors({
                          ...errors,
                          mobile_no: null,
                        });
                      }, 2500);
                    }}
                    title={t(`Organization.SPOC.Mobile`)}
                  />
                  {errors?.mobile_no && (
                    <p className="text-danger">{errors?.mobile_no}</p>
                  )}
                </Form.Group>
              </Col>

              <Col md={12} className="">
                <Form.Group className="mb-2 floating-label">
                  <Form.Label className="float-label">
                    {t(`Organization.SPOC.Role`)}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    placeholder={t(`Organization.SPOC.Enter Role`)}
                    type="text"
                    name="role"
                    value={spocDetails?.role}
                    onChange={e => {
                      setSPOCDetails({
                        ...spocDetails,
                        role: e.target.value,
                      });
                    }}
                    title={t(`Organization.SPOC.Role`)}
                  />
                   {errors?.role && (
                    <p className="text-danger">{errors?.role}</p>
                  )}
                </Form.Group>
              </Col>

              <Col md={12} className="d-flex gap-2 mt-4">
                <button
                  className="btn btn-primary reset"
                  onClick={() => {
                    toggleAddModal();
                  }}
                >
                  {t(`Organization.SPOC.Cancel`)}
                </button>
                <button
                  className="btn btn-primary search"
                  onClick={() => handleSaveClick()}
                >
                  {t(`Organization.SPOC.Save`)}
                </button>
              </Col>
            </Row>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CreateSPOCModal;
